<small class="powered-by">Powered By: 24Network Team <i class="material-icons" (click)="core.debug_expose()">favorite</i></small>
<a class="contact-us icon-text" href="mailto:{{ contact_email }}" *ngIf="contact_email">
	<i class="material-icons">mail_outline</i>
	<small>email us</small>
</a>

<!--a class="version-history icon-text" routerLink="/devlog">
	<i class="material-icons">code</i>
	<small>devlog</small>
</a-->

<button class="report-issue icon-text" (click)="reportConfirming=true">
	<i class="material-icons">code</i>
	<small>Report a Problem</small>
</button>

<a class="settings" (click)="core.redirectTo('/settings', true)">
	<i class="material-icons">settings</i>
	<small>Settings</small>
</a>


<div class="report-wrapper">
	<div class="report">
	</div>
</div>

<div class="report-panel"
	#report_panel [class.active]="reportConfirming"
	(click)="close_report_panel($event, report_panel)">
	<div class="inner-modal report">
		<button class="close material-icons" (click)="reportConfirming=false;">close</button>
		<span class="title">
			@if( profile.is_authenticated ){
				Something wrong? Send us a report!
			} @else {
				<b class="login" (click)="login_click()">Please Login before sending us a report!</b>
			}
			@if( report_error_message ){
				<br/><span class="error">{{ report_error_message }}</span>
			}
		</span>
		<div class="formbox" [class.disabled]="!profile.is_authenticated">
			<select [(ngModel)]="report_type">
				<option value=''> - What is this about? - </option>
				<option value='unlisted'>Missing Game / Feed</option>
				<option value='odds'>Betsim / Prediction</option>
				<option value='video'>Video Issue</option>
				<option value='other'>Other</option>
			</select>

			<p>
				Describe the issue in the field below,<br/>
				Also consider providing the following for easier disagnostics:<br/>
				- Your Browser and Operating System / Device<br/>
				- Whether you're using a VPN or not
			</p>
			<textarea name="description" rows="6" [(ngModel)]="report_description"></textarea>

			<label name="include_log" [class.hidden]="!player.last_player_error">
				Should this report also include the last crash report of the video player?
				<input type="checkbox" name="include_log" [(ngModel)]="report_include_log"/>
			</label>

			<button class="submit" (click)="report_submit()">Submit Report</button>

		</div>
	</div>
</div>
